import React from 'react';
import { Link } from 'react-router-dom';
import { isExternalUrl } from '../../util/url';

interface LinkOrAnchorProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  target?: string;
  rel?: string;
}

const LinkOrAnchor = ({
  to,
  children,
  className,
  target,
  rel,
}: LinkOrAnchorProps) => {
  if (!to) {
    return <>{children}</>;
  }

  if (isExternalUrl(to)) {
    return (
      <a
        href={to}
        className={className}
        target={target ?? '_blank'}
        rel={rel ?? 'noopener noreferrer'}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  );
};

export default LinkOrAnchor;
